import React from "react";
import "./styles.css";

const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-box">
        <div className="spinner"></div>
        <p>Đang tải dữ liệu...</p>
      </div>
    </div>
  );
};

export default Loading;
